export interface PayoutResults {
  first?: number
  second?: number
  third?: number
  fourth?: number
  fifth?: number
  totalPurse?: number
  totalCollection: number
}


const distributions = [[100], [70, 30], [50, 30, 20], [50, 25, 15, 10], [40, 25, 20, 10, 5]]

export const payoutInputErrors = (players: number, buyIn: number, bounty: number) => ({
  numberOfPlayers: Number.isInteger(players) && players >= 2 && players <= 30 ? undefined : 'Enter a whole number of players from 2 through 30.',
  buyInAmount: Number.isInteger(buyIn) && buyIn >= 1 ? undefined : 'Enter a whole-dollar buy-in of at least $1.',
  bountyAmount: Number.isInteger(bounty) && bounty >= 0 ? undefined : 'Enter a whole-dollar bounty of $0 or more.'
})

function prizesForPool(pool: number, paidPlaces: number): number[] {
  if (paidPlaces === 1) return [pool]
  const prizes = distributions[paidPlaces - 1].map(percent => Math.round(pool * percent / 500) * 5)
  prizes[prizes.length - 1] += pool - prizes.reduce((sum, prize) => sum + prize, 0)
  return prizes.every((prize, index) => prize > 0 && (index === 0 || prize <= prizes[index - 1]))
    ? prizes : prizesForPool(pool, paidPlaces - 1)
}

export default {
  calculate: (numberOfPlayers: number, buyInAmount: number, bountyAmount = 0): PayoutResults | null => {
    if (Object.values(payoutInputErrors(numberOfPlayers, buyInAmount, bountyAmount)).some(Boolean)) return null
    const totalPurse = numberOfPlayers * buyInAmount
    const paidPlaces = numberOfPlayers <= 3 ? numberOfPlayers - 1 : numberOfPlayers <= 10 ? 3 : numberOfPlayers <= 20 ? 4 : 5
    const [first, second, third, fourth, fifth] = prizesForPool(totalPurse, paidPlaces)
    return {first, second, third, fourth, fifth, totalPurse, totalCollection: totalPurse + bountyAmount * numberOfPlayers}
  }
}
